import { startCase } from 'lodash';
import { EUserVisibility } from '@timeedit/types';
import { TEEFilterType, type TEIFilterField } from '@timeedit/ui-components';

export const filterFields: TEIFilterField[] = [
  {
    key: 'active',
    label: 'Active',
    type: TEEFilterType.boolean,
  },
  {
    key: 'standardOrganization',
    label: 'Standard organization',
    type: TEEFilterType.treeSelect,
    multiselect: false,
  },
  {
    key: 'authConfigId',
    label: 'Auth Config',
    type: TEEFilterType.text,
  },
];

export const optionalFilterFields: TEIFilterField[] = [
  {
    key: 'visibility',
    label: 'Visibility',
    type: TEEFilterType.text,
  },
  {
    key: 'scopes',
    label: 'Scopes',
    type: TEEFilterType.text,
  },
  {
    key: 'appPermissions',
    label: 'App Permissions',
    type: TEEFilterType.text,
  },
  {
    key: 'organizationNode',
    label: 'Organization node',
    type: TEEFilterType.text,
    multiselect: false,
  },
  {
    key: 'lockedForExternalAuthentication',
    label: 'Locked',
    type: TEEFilterType.boolean,
  },
  {
    key: 'lastLoginAt',
    label: 'Last Login',
    type: TEEFilterType.rangePicker,
  },
];

export const getVisibilityOptions = (includeHidden: boolean) =>
  Object.keys(EUserVisibility)
    .map((key) => ({
      value: key,
      label: startCase(key.toLowerCase().replaceAll('_', ' ')),
    }))
    .filter((v) => includeHidden || v.value !== EUserVisibility.HIDDEN);

export const lockedOptions = [
  {
    value: 'true',
    label: 'Locked',
  },
  {
    value: 'false',
    label: 'Not locked',
  },
];
